import './anchor-nav.scss';

import { getOffset, smoothScrollTo } from '../../../utilities/js/helper';

class AnchorNav {
    constructor ($element) {
        this.$anchorNav = $element;
        this.$anchorContent = this.$anchorNav.querySelector('[data-anchor-nav="content"]');
        this.$anchorList = this.$anchorNav.querySelector('[data-anchor-nav="list"]');
        this.$switch = this.$anchorNav.querySelector('[data-anchor-nav="switch"]');
        this.$anchors = [].slice.call(document.querySelectorAll('[data-anchor-nav-name]'));
        this.isOpen = false;
        this.editMode = this.$anchorNav.classList.contains('is--editmode');
        this.$lottery = document.querySelector('[id="lotterie"]');

        this.anchorPositions = [];
    }

    initialize () {
        if (!this.editMode) {
            this.generateAnchors(() => {
                this.getAnchorPositions();
            });

            this.setEvents();

            setTimeout(() => {
                this.checkPosition();
            }, 1000);

            this.checkSize();
        }
    }

    generateAnchors (callback) {
        this.$anchors.forEach((anchor) => {
            let template = '';
            const name = anchor.getAttribute('data-anchor-nav-name');
            const id = anchor.getAttribute('id');
            const item = document.createElement('li');
            item.classList.add('anchor-nav__anchor-item');

            template += `<button data-scroll-to="#${id}" class="is--variable hover-link"><span class="screenreader-only">${this.$anchorList.dataset.anchorNavMessage}</span> ${name}</button>`;
            item.innerHTML = template;
            this.$anchorList.appendChild(item);

            item.firstChild.addEventListener('click', () => {
                let posAdjust = (this.$anchorNav.scrollHeight * (-1));
                if (window.innerWidth < 1280) {
                    posAdjust = (this.$anchorNav.scrollHeight * (-1));
                }

                const posY = getOffset(document.getElementById(id)).top + posAdjust;
                smoothScrollTo(0, posY, 500);
                this.closeNavigation();

                anchor.setAttribute('tabindex', '0');
                setTimeout(() => {
                    anchor.focus();
                    clearTimeout();

                    setTimeout(() => {
                        anchor.removeAttribute('tabindex', '0');
                        clearTimeout();
                    }, 500);
                }, 200);
            });
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    getAnchorPositions () {
        let lotteryPos = null;
        let lotteryPushed = false;

        if (this.$lottery) {
            lotteryPos = getOffset(this.$lottery).top;
        }

        this.$anchors.forEach((anchor) => {
            if (lotteryPos !== null && lotteryPushed === false) {
                if (lotteryPos < anchor.getBoundingClientRect().top - document.body.getBoundingClientRect().top) {
                    const $lotteryAnchor = this.$anchorNav.querySelector('[data-scroll-to="#' + this.$lottery.getAttribute('id') + '"]');
                    if ($lotteryAnchor) {
                        this.anchorPositions.push(
                            {
                                id: this.$lottery.getAttribute('id'),
                                offsetTop: lotteryPos,
                                element: this.$lottery,
                                anchor: $lotteryAnchor
                            }
                        );
                        lotteryPushed = true;
                    }
                }
            }

            const $anchor = this.$anchorNav.querySelector('[data-scroll-to="#' + anchor.getAttribute('id') + '"]');

            if ($anchor) {
                this.anchorPositions.push(
                    {
                        id: anchor.getAttribute('id'),
                        offsetTop: anchor.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
                        element: anchor,
                        anchor: $anchor
                    }
                );
            }
        });
    }

    setEvents () {
        this.$switch.addEventListener('click', () => {
            if (this.isOpen) {
                this.closeNavigation();
            } else {
                this.openNavigation();
            }
        });

        window.resizeHandler.customFunctions.push(() => {
            this.getAnchorPositions();
        });
    }

    closeNavigation () {
        this.$anchorContent.style.height = '';
        this.$switch.classList.remove('is--open');
        this.isOpen = false;

        this.$anchorContent.setAttribute('data-aria-hidden', !this.isOpen);
        this.$switch.setAttribute('aria-pressed', this.isOpen);
    }

    openNavigation () {
        this.$anchorContent.style.height = this.$anchorContent.scrollHeight + 'px';
        this.$switch.classList.add('is--open');
        this.isOpen = true;

        this.$anchorContent.setAttribute('data-aria-hidden', !this.isOpen);
        this.$switch.setAttribute('aria-pressed', this.isOpen);
    }

    isInViewport (element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    checkPosition () {
        window.eventScroller.customFunctions.push(() => {
            this.anchorPositions.forEach((anchor, index) => {
                if (this.isInViewport(anchor.element)) {
                    anchor.anchor.classList.add('is--active');
                } else {
                    anchor.anchor.classList.remove('is--active');
                }
            });
        });
    }

    checkSize () {
        document.addEventListener('design_xl', () => {
            this.closeNavigation();
        });
    }
}

export { AnchorNav };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $anchorNavigation = $context.querySelector('[data-anchor-nav="root"]');

    if ($anchorNavigation) {
        const AnchorNavigation = new AnchorNav($anchorNavigation);
        AnchorNavigation.initialize();
    }
});
